export default __webpack_public_path__ + "static/media/02.107a25b4.png";